import styled from 'styled-components';

export const SlaActivityHistoryWrapper = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.1rem;
  max-width: calc(100% - 1.1rem);
  width: 100%;
  font-size: 0.75rem;
  font-weight: 400;
  color: #656f7d;
  position: relative;
  padding: 0.5rem 0;

  & > span {
    font-size: 0.625rem;
    color: #656f7d;
  }

  & > #sla_history-info-protocol-id {
    min-width: 30%;
    display: flex;
    font-size: 0.75rem;
    justify-content: flex-end;
  }

  &::before {
    content: '';
    width: 0.25rem;
    height: 0.25rem;
    border-radius: 100%;
    background-color: #656f7d;
    position: absolute;
    left: -0.75rem;
    top: calc(50% - 0.125rem);
  }
`;
